import { RefObject, useEffect, useRef } from 'react'

export interface ILatchedReason {
    problemID?: number;
    resonID?: number;
}

export interface ILatchedReasonState {
    identity: string;
    values: ILatchedReason;
}

export interface IReasonSource {
    props?: { problemID?: number | null; resonID?: number | null } | null;
}

// Латч причины (אישור מנהל и др.) на одну сущность entry-модалки.
// resonState.props.{problemID,resonID} фиксируются в момент появления и переживают
// сброс контекста; смена identityKey (подмена товара в открытой модалке) делает
// латч недействительным — сброс происходит в render-фазе, до эффектов, чтобы не
// стереть свежезалоченное значение нового товара.
export const useLatchedReason = (resonState: IReasonSource | null | undefined, identityKey: string): RefObject<ILatchedReasonState> => {
    const ref = useRef<ILatchedReasonState>({ identity: identityKey, values: {} })
    if (ref.current.identity !== identityKey) {
        ref.current = { identity: identityKey, values: {} }
    }
    // deps намеренно опущены: перелатчивание обязано идти в том же коммите, что и
    // render-фазный сброс выше — deps-массив вернул бы баг «свежая причина стёрта».
    // Смена идентичности не тянет старую причину, потому что getGoodsInfoEntry
    // сбрасывает resonState ДО setDefaultPacks (нового ключа); в подфлоу замены
    // (setDefProd → новый RecID) перелатчивание пришедшей причины — желаемое.
    useEffect(() => {
        if (resonState?.props?.resonID != null || resonState?.props?.problemID != null) {
            ref.current.values = {
                problemID: resonState.props.problemID ?? undefined,
                resonID: resonState.props.resonID ?? undefined,
            }
        }
    })
    return ref
}
